module.exports = __webpack_public_path__ + "img/ledger-city-highlights.3ccb2efc.png";